export default __webpack_public_path__ + "media/zurb/img/legacy/chop/2-b99a909f4080c40dfff9e4ce94942fc9.png";